// extracted by mini-css-extract-plugin
export default {"backLink":"app-assets-javascripts-components-backLink-backLink__backLink--w6NHP"};